import React, { Component } from 'react';
import { Link } from "react-router-dom";
import SkyLight from 'react-skylight'

export default class Dialog extends Component {
    render() {
        const myDialog = {
            // backgroundColor: '#00897B',
            // color: '#ffffff',
            width: 300/375*100+'vw',
            height: 300/375*100+'vw',
            minHeight: 300/375*100/2+'vw',
            marginTop: -300/375*100/2+'vw',
            marginLeft: -300/375*100/2+'vw',
            boxSizing: 'border-box',
            borderRadius: 10/375*100+'vw'
        }
        return <section className="main">

            {/* 按钮 */}
            <div className="Lmt10">
                <Link to="/" className="btn btn-primary btn-large">
                    去首页
                </Link>
                <Link to="/demo" className="btn btn-default btn-large Lmt10">
                    去Demo
                </Link>
            </div>

            <div className="Lmt10">
                <button className="btn btn-primary" onClick={() => this.simpleDialog.show()}>打开弹窗</button>
            </div>

            {/* 弹窗 */}
            <SkyLight dialogStyles={myDialog} hideOnOverlayClicked ref={ref => this.simpleDialog = ref} title="活动规则：">
                <div className="popup-scroll">
                    <p>1、活动时间：2018年5月31日-6月30日</p>

                    <p>2、活动期间，华住会会员在华住会官方渠道预订CitiGO旗下任一酒店并全额预付，即可享受门市价8折起优惠；</p>

                    <p>3、本活动可享受单份早餐，不支持续住；</p>

                    <p>4、酒店房量有限，先订先得；</p>

                    <p>5、请在下单1小时之内在线支付，否则订单将被取消；</p>

                    <p>6、如行程有变，可在入住当天12点前取消订单；</p>

                    <p>7、活动期间，通过本活动页面预订并入住CitiGO旗下任一酒店，每天前十位入住的用户，将获得1个洗漱包/金银杯/夜宵/欢迎水果（具体视每家门店情况而定）</p>

                    <p>8、如有疑问，可拨打CitiGO客服电话：4000119966</p>
                </div>
            </SkyLight>
        </section>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js